import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';
import { marginLeft } from 'utils';

export const StyledQuote = styled('div')(
  () => css`
    background: #ffffff;
    border: 1px solid #ccd5dc;
    border-radius: 6px;
    padding: 8px;
    width: -webkit-fill-available;
    margin-top: 8px;
    color: #000000;
    text-align: right;

    .header {
      .avatar-image {
        width: 36px;
        height: 36px;
        border: 1px solid #edf2f7;
        box-shadow: 0px 3px 8px -1px rgba(50, 50, 71, 0.05);
        border-radius: 6px;
        margin-right: 8px;
        margin-left: 8px;
      }

      .title {
        font-weight: bold;
        font-size: 0.875rem;
        line-height: 24px;
        ${marginLeft('8px')}
      }

      .username {
        color: #777;
      }
    }

    /* Doubled selector so the detail pages' generic ".ui-card-body .title" margin can't leak in */
    && .header .title {
      margin-bottom: 0;
    }
  `
);
